module.exports = __webpack_public_path__ + "static/media/medium-instrumental.703d6244.png";